
import classes from './AverageSubmissions.module.css'
import AverageSubmissionsChart from "./AverageSubmissionsChart"
import { useSelector } from 'react-redux';

const AverageSubmissions = ({ avergeScore, avergeClass, generalAverageText }) => {

    const texts = useSelector(state => state.translate.texts);
    return (
        <div className={classes.SubmissionIconScore}>
            <div className={classes.SubmissionScoreTitle}>
                <div className={classes.SubmissionIcon}></div>
                <div >{texts.averageSubmissions}</div>
            </div>
            <div className={classes.SubmissionScoreTxt}>{avergeScore ? Math.round(avergeScore * 10) / 10 : 0}<span className={classes.SubmissionScorePercent}>%</span></div>
            <AverageSubmissionsChart avergeScore={avergeScore ? avergeScore : 0} avergeClass={avergeClass ? avergeClass : 0} generalAverageText={generalAverageText}> </AverageSubmissionsChart>
        </div>
    )
}
export default AverageSubmissions